export default {
  getSignika: () => 'Signika',
  getHalisR: () => 'HalisR',
};
